import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchOverlay from "@/components/feature/SearchOverlay";

const navItems = [
  { label: "首页", to: "/" },
  { label: "影片", to: "/films" },
  { label: "放映动态", to: "/screenings" },
  { label: "技术介绍", to: "/technology" },
  { label: "观影指南", to: "/guide" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome;

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
          solid
            ? "bg-background-100/95 backdrop-blur-md border-b border-background-200/70"
            : "bg-gradient-to-b from-background-50/80 to-transparent"
        }`}
      >
        <div className="w-full h-20 px-4 md:px-8 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xl">
              <i className="ri-planet-line" />
            </span>
            <span className="font-heading font-bold text-lg text-foreground-950 whitespace-nowrap">
              球幕影院
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-3.5 py-2 rounded-md text-sm font-label transition-colors whitespace-nowrap cursor-pointer ${
                    isActive
                      ? "text-accent-500 bg-accent-500/10"
                      : "text-foreground-700 hover:text-foreground-950 hover:bg-background-200/60"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2 shrink-0">
            <button
              type="button"
              onClick={() => setSearchOpen(true)}
              aria-label="搜索影片"
              className="w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:text-accent-500 hover:bg-background-200/60 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-lg" />
            </button>
            <Link
              to="/screenings"
              className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-accent-500 text-background-50 text-sm font-label font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-ticket-2-line" />
              立即购票
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开导航菜单"
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-900 hover:bg-background-200/60 transition-colors cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="lg:hidden bg-background-100 border-t border-background-200/70 px-4 py-4">
            <nav className="flex flex-col gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) =>
                    `px-4 py-3 rounded-md text-sm font-label transition-colors cursor-pointer ${
                      isActive
                        ? "text-accent-500 bg-accent-500/10"
                        : "text-foreground-800 hover:bg-background-200/60"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        )}
      </header>

      {searchOpen && <SearchOverlay onClose={() => setSearchOpen(false)} />}
    </>
  );
}